import C from '../../Resume.module.scss';
import S from './EtcEdit.module.scss';
import SelectDateBox from '../../../../common/SelectDateBox';
import {CareerType, MilitaryServiceInfoType, ResumeTabsType, ResumeType} from '../../../../../types/ResumeTypes';
import React, {Dispatch, SetStateAction} from "react";
import {DateTimeUtils} from "../../../../../utils/DateTimeUtils";

interface EtcEditProps {
  resumeTabs: ResumeTabsType;
  setResume: Dispatch<SetStateAction<ResumeType>>;
  militaryServiceInfo: MilitaryServiceInfoType;
  veteranStatus: boolean; // 보훈 대상여부
  veteranRelation: string; // 보훈 관계 목록
  disabilityStatus: boolean; // 장애 대상여부
  disabilityGrade: string; // 장애 정도
}

const EtcEdit = (props: EtcEditProps) => {
  const { resumeTabs , setResume, disabilityGrade, disabilityStatus, veteranStatus, veteranRelation, militaryServiceInfo} = props;

  const updateField = (fieldName: keyof MilitaryServiceInfoType, value: string) => {
      setResume((prevResume) => ({
        ...prevResume,
        militaryServiceInfo: { ...prevResume.militaryServiceInfo, [fieldName]: value },
      }));
  };

  const updateMilitaryStartAtField = (value: Date) => {
    updateField('startAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  const updateMilitaryEndAtField = (value: Date) => {
    updateField('endAt', DateTimeUtils.toDateStringYYYYMM(value));
  };

  if(militaryServiceInfo === undefined){
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[5].element} className={`${C.basic_edit_section} wrapper`}>
        <h4 className={`${C.basic_edit_title} h4`}>기타사항</h4>
        <div className={C.basic_wrap}>
          <div className={C.basic_title}>
            <p className="b1">취업우대/병역</p>
            <span className={C.red_dot}></span>
          </div>
          <div className={C.basic_input_wrap}>
            <div className={`${C.basic_edit_input}`}>
              {/* 군필 여부 */}
              <select
                name="status"
                id="military_status"
                className="input-border input-select"
                value={militaryServiceInfo.status}
                onChange={(e) => {
                  updateField('status', e.target.value);
                }}
              >
                <option value="">군필 여부 *</option>
                <option value="Completed">필</option>
                <option value="NotCompleted">복무중</option>
                <option value="Exempt">면제</option>
                <option value="None">미필</option>
              </select>

              {/* 군 면제 사유 */}
              {militaryServiceInfo.status === 'Exempt' && (
                <select
                  name="militaryRejectReason"
                  id="militaryRejectReason"
                  className="input-border input-select"
                  value={militaryServiceInfo.reason}
                  onChange={(e) => {
                    updateField('reason', e.target.value);
                  }}
                >
                  <option value="">군 면제 사유 *</option>
                  <option value="없음">없음</option>
                  <option value="신체문제">신체문제</option>
                  <option value="생계곤란">생계곤란</option>
                  <option value="기타사유">기타사유</option>
                </select>
              )}

              {(militaryServiceInfo?.status === 'Completed' ||
                  militaryServiceInfo?.status === 'NotCompleted') && (
              <div className={C.resume_period_date}>
                <SelectDateBox
                  selectedDate={DateTimeUtils.stringToDateType(
                    militaryServiceInfo.startAt,
                    'YYYY-MM',
                  )}
                  setSelectedDate={updateMilitaryStartAtField}
                  type={'military-start-date'}
                />
              </div>
              )}

              {militaryServiceInfo?.status === 'Completed' && (
              <div className={C.resume_period_date}>
                <SelectDateBox
                  selectedDate={DateTimeUtils.stringToDateType(
                    militaryServiceInfo.endAt,
                    'YYYY-MM',
                  )}
                  setSelectedDate={updateMilitaryEndAtField}
                  type={'military-end-date'}
                />
              </div>
              )}

              {/* 보훈 대상여부 */}
              <select
                name="veteransStatus"
                id="veterans_status"
                className="input-border input-select"
                value={String(veteranStatus)}
                onChange={(e) => {
                  setResume((prev) => ({
                    ...prev,
                    veteranStatus: e.target.value === 'true',
                  }));
                }}
              >
                <option value="">보훈 대상여부 *</option>
                <option value="false">아니오</option>
                <option value="true">예</option>
              </select>

              {/* 보훈 관계 */}
              <select
                name="veteranRelation"
                id="veterans_relation"
                className="input-border input-select"
                value={veteranRelation}
                onChange={(e) => {
                  setResume((prev) => ({
                    ...prev,
                    veteranRelation: e.target.value,
                  }));
                }}
              >
                <option value="">보훈 관계 *</option>
                <option value="대상(본인)">대상(본인)</option>
                <option value="대상(가족)">대상(가족)</option>
                <option value="대상(유족)">대상(유족)</option>
              </select>

              {/* 장애 대상여부 */}
              <select
                name="disabilityStatus"
                id="disability_status"
                className="input-border input-select"
                value={String(disabilityStatus)}
                onChange={(e) => {
                  setResume((prev) => ({
                    ...prev,
                    disabilityStatus: e.target.value === 'true',
                  }));
                }}
              >
                <option value="">장애 대상여부 *</option>
                <option value="false">아니오</option>
                <option value="true">예</option>
              </select>

              {/* 장애 정도 */}
              <select
                name="disabilityGrade"
                id="disability_grade"
                className="input-border input-select"
                value={disabilityGrade}
                onChange={(e) => {
                  setResume((prev) => ({
                    ...prev,
                    disabilityGrade: e.target.value,
                  }));
                }}
              >
                <option value="">장애 정도 *</option>
                <option value="심한 장애인">심한 장애인</option>
                <option value="심하지 않은 장애인">심하지 않은 장애인</option>
              </select>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </>
  );
};

export default EtcEdit;
